import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  return <section className="py-20 bg-brand-dark relative overflow-hidden" data-id="element-154">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-brand-orange to-transparent opacity-50" data-id="element-155" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-157">
          <h2 className="text-4xl md:text-5xl mb-8 uppercase" data-id="element-158">
            PRESENTAMOS EL MÉTODO{' '}
            <span className="bg-brand-orange text-white px-3 py-1 rounded-md inline-block mt-2 md:mt-0" data-id="element-159">
              "MUEBLE-FIT"
            </span>
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed text-zinc-300 mb-12" data-id="element-160">
            He diseñado un sistema que hackea la arquitectura de tu hogar. En
            este manual, aprenderás a utilizar la física, la gravedad y los
            objetos que ya tienes (sillas, mochilas, toallas) para generar una
            tensión muscular que nada tiene que envidiarle a las máquinas
            comerciales. Es ciencia aplicada al living de tu casa para maximizar
            resultados en sesiones de menos de 30 minutos.
          </p>

          <div className="relative w-full max-w-2xl mx-auto" data-id="element-161">
            <div className="absolute inset-0 bg-brand-orange blur-[80px] opacity-10 rounded-full" data-id="element-162" />
            <img src="https://cdn.magicpatterns.com/uploads/b2b82axgfL6Aj9NqHmhspg/El_manual_del_gym.png" alt="Método Mueble-Fit" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-zinc-800/50" data-id="element-163" />
          </div>
        </motion.div>
      </div>
    </section>;
}